/**
 * File name of a document URL. Presigned URLs carry a query string, so `split('/').pop()`
 * returns `name.pdf?X-Amz-...`; read the pathname instead.
 */
/**
 * Lower-case extension of a document URL without the dot ('' when none). Read off the pathname,
 * so a presigned query string cannot hide or fake it.
 */
export function documentExtension(url: string | null | undefined): string {
  if (!url) return ''
  try {
    const last = new URL(url).pathname.split('/').pop() || ''
    const dot = last.lastIndexOf('.')
    return dot === -1 ? '' : last.slice(dot + 1).toLowerCase()
  } catch {
    return ''
  }
}

export function documentFileName(url: string, fallback = 'file'): string {
  if (!url) return fallback
  try {
    const last = new URL(url).pathname.split('/').pop() || ''
    const decoded = decodeURIComponent(last.replace(/\+/g, ' '))
    return decoded || fallback
  } catch {
    return fallback
  }
}
